import { useIntl } from "@grandvisionhq/state";
const useFacetLabel = ({ facet }) => {
  const { getLabel } = useIntl();
  return facet.label ?? getLabel(facet.labelKey || facet.id);
};
export {
  useFacetLabel
};
//# sourceMappingURL=use-facet-label.js.map
